import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "doc_ic",
  "use": "doc_ic-usage",
  "viewBox": "0 0 17 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 22\" id=\"doc_ic\"><g fill-rule=\"nonzero\" fill=\"none\"><path fill=\"#42B4E6\" d=\"M0 0h10.973L17 6.063V22H0z\" /><path fill=\"#157398\" d=\"M11 0l6 6h-6z\" /><path fill=\"#FFF\" d=\"M3 10h4v1H3zM3 12h10v1H3zM3 14h10v1H3zM3 16h6v1H3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol